import {formatImageContent} from "@/components/file_process_js/ function_process/vision_process";
import {commitMatchDataTask} from "@/api/fetch_parse_result";
import {
    extractAndParseJsonFromBox,
    fileStatusChange,
    getOrgImageKeys,
    pollingRefreshFileInfo
} from "@/components/file_process_js/utils";
import store from "@/store";
import {commitFileLLMAnalyseTask, getFileLLMPreAnalyse} from "@/api/file_llm_analyse";
import {file} from "jszip";


function filePreAnalyseMDWarp(filePreAnalysePrompt, label_to_param_config, engine) {
    async function filePreAnalyseMD(fileInfo) {
        // await getPreAnalyse(fileInfo, filePreAnalysePrompt)

        await preAnalyseTask(fileInfo, filePreAnalysePrompt, engine)

        applyPreAnalyseV2(fileInfo, label_to_param_config)

        // //兼容旧版本数据渲染
        // if (fileInfo.version && fileInfo.version >= 2) {
        //
        // } else {
        //     // 需要兼容旧版的标签继续往下走
        //     applyPreAnalyse(fileInfo, label_to_param_config);
        // }
    }

    return filePreAnalyseMD
}

// v2.0 后废弃
async function getPreAnalyse(fileInfo, filePreAnalysePrompt) {
    const orgImageKeys = getOrgImageKeys(fileInfo)

    if (fileInfo.status_code >= 299 || fileInfo.status_code < 0 || fileInfo.labels.length > 0) {
        return
    }

    const tasks = [{
        "prompt": {"user": filePreAnalysePrompt},
        "task_key": "pre_analyse",
        "split": false
    }]
    const newFileInfo = await getFileLLMPreAnalyse(
        fileInfo.id,
        fileInfo.file_key,
        fileInfo.root_key,
        fileInfo.file_hash,
        orgImageKeys,
        fileInfo.project_id,
        tasks,
        fileInfo.status_code % 100 === 1
    )
    if (!newFileInfo || newFileInfo.error) {
        console.error("getPreAnalyse", newFileInfo, fileInfo)
        fileStatusChange(fileInfo, "pre_analyse failed", -209)
    } else {
        fileInfo.status_code = newFileInfo.status_code
        fileInfo.status = newFileInfo.status
        fileInfo.file_pre_analyse = newFileInfo.file_pre_analyse
    }

}


async function preAnalyseTask(fileInfo, filePreAnalysePrompt, engine) {
    if (fileInfo.status_code >= 299 || fileInfo.status_code < 0 || fileInfo.labels.length > 0) {
        return
    }
    // console.log("preAnalyseTask", fileInfo, filePreAnalysePrompt);

    const tasks = []
    const orgImageKeys = getOrgImageKeys(fileInfo)
    // 按照每页img 单独打标签
    orgImageKeys.forEach(imageKey => {
        tasks.push({
            "prompt": {"user": filePreAnalysePrompt},
            "task_key": "pre_analyse",
            "image_keys": [imageKey],
            "split": true,
            "no_struct_text": "",
            "engine": engine
        })
    })

    fileStatusChange(fileInfo, "file pre analysing")
    // console.log(" commitFileLLMAnalyseTask fileInfo", fileInfo, fileInfo["file_image_keys"])

    // 预解析不需要文字
    const noStructText = []
    try {
        await commitFileLLMAnalyseTask(
            {
                file_id: fileInfo.id,
                fileKey: fileInfo.file_key,
                rootKey: fileInfo.root_key,
                fileHash: fileInfo.file_hash,
                imageKeys: orgImageKeys,
                projectId: fileInfo.project_id,
                noStructText: noStructText,
                tasks: tasks,
                status_code: fileInfo.status_code,
                analyse_type: "pre_analyse"
            })
    } catch (e) {
        console.error("commitFileLLMAnalyseTask fail", e)
        fileStatusChange(fileInfo, "标签解析111失败", -299)
    }

    await pollingRefreshFileInfo(fileInfo, breakFunction, callbackGetLabelWarp(fileInfo), 50, 5000);
}


function breakFunction(remoteFileInfo) {
    return remoteFileInfo.status_code < 0 || remoteFileInfo.status_code >= 299
}

function updatePreAnalysedFileInfo(fileInfo, remoteFileInfo) {
    const syncAttrs = ["file_pre_analyse_log", "status_code", "status"]
    syncAttrs.forEach(attr => {
        fileInfo[attr] = remoteFileInfo[attr]
    })
}


function callbackGetLabelWarp(fileInfo) {
    return (remoteFileInfo) => {
        updatePreAnalysedFileInfo(fileInfo, remoteFileInfo)
        console.log("callbackGetLabelWarp fileInfo", remoteFileInfo, fileInfo);
    }
}

// v2.0 后废弃
function applyPreAnalyse(fileInfo, label_to_param_config) {
    if (fileInfo.status_code < 0) {
        return
    }

    const perLabelRes = extractAndParseJsonFromBox(fileInfo.file_pre_analyse)
    const language = perLabelRes.language
    const labels = perLabelRes.labels
    if (!language || !labels) {
        console.error("getPreAnalyse fail, please check", fileInfo)
        return
    }


    if (labels.length === 0) {
        fileStatusChange(fileInfo, "无标签数据", -298)
    }
    let labelAllValid = true
    labels.forEach((label) => {
        if (!label_to_param_config[label]) {
            labelAllValid = false
        }
    })

    if (labelAllValid) {
        fileInfo.labels = labels
        fileInfo.language = language
    } else {
        fileStatusChange(fileInfo, "标签解析异常", -299)
    }
}

// 为每个视觉分页单独设置一个标签
function applyPreAnalyseV2(fileInfo, label_to_param_config) {
    if (fileInfo.status_code < 0) {
        return
    }

    if (!fileInfo.file_pre_analyse_log || fileInfo.file_pre_analyse_log.length !== fileInfo.file_vision.length) {
        fileStatusChange(fileInfo, "标签解析异常", -299)
    }

    const totalLabels = [];
    const totalLanguage = [];
    let totalParseStr = []

    for (let i = 0; i < fileInfo.file_pre_analyse_log.length; ++i) {
        const log = fileInfo.file_pre_analyse_log[i]
        totalParseStr.push(log["llm_response"])

        if (!log || log.status !== "COMPLETED") {
            fileInfo.file_vision[i]["pre_analyse_status"] = "label Valid"
            fileInfo.file_vision[i]["pre_analyse_status_code"] = "-299"
            continue
        }
        const perLabelRes = extractAndParseJsonFromBox(log["llm_response"])
        const language = perLabelRes.language
        const labels = perLabelRes.labels
        if (!language || !labels) {
            fileInfo.file_vision[i]["pre_analyse_status"] = "empty language; empty labels"
            fileInfo.file_vision[i]["pre_analyse_status_code"] = "-299"
            continue
        }

        let labelAllValid = true
        labels.forEach((label) => {
            if (!label_to_param_config[label]) {
                labelAllValid = false
            }
        })

        if (labelAllValid) {
            totalLabels.push(...labels)
            totalLanguage.push(...language)
            fileInfo.file_vision[i]["labels"] = labels
            fileInfo.file_vision[i]["language"] = language
        } else {
            fileInfo.file_vision[i]["pre_analyse_status"] = "label Valid"
            fileInfo.file_vision[i]["pre_analyse_status_code"] = "-299"
        }
    }

    if (totalLabels.length === 0) {
        fileStatusChange(fileInfo, "无标签数据", -298)
    }
    fileInfo.file_pre_analyse = totalParseStr
    fileInfo.labels = [...new Set(totalLabels)]
    fileInfo.language = [...new Set(totalLanguage)]
}


export function getPreAnalyseMD(fileInfo) {
    const mainConfig = store.state.mainConfig
    const filePreAnalysePrompt = mainConfig.file_pre_analyse_prompt
    const label_to_param_config = mainConfig.label_to_param_config
    const engine = mainConfig.file_pre_analyse_engine || "gemini_flash"
    return filePreAnalyseMDWarp(filePreAnalysePrompt, label_to_param_config, engine);
}